import { Link } from 'react-router';
import { FaHome, FaComments } from 'react-icons/fa';
import { MdErrorOutline } from 'react-icons/md';

export default function NotFound() {
    return (
        <div className="min-h-screen bg-background flex items-center justify-center px-4">
            <div className="max-w-2xl w-full text-center">
                {/* Error Icon */}
                <div className="mb-8 flex justify-center">
                    <div className="relative">
                        <div className="absolute inset-0 bg-primary/20 rounded-full blur-2xl animate-pulse"></div>
                        <MdErrorOutline className="relative text-primary text-9xl md:text-[12rem]" />
                    </div>
                </div>

                {/* 404 Text */}
                <h1 className="text-8xl md:text-9xl font-bold text-secondary dark:text-dark-text mb-4 tracking-tight">
                    404
                </h1>

                {/* Error Message */}
                <h2 className="text-2xl md:text-3xl font-semibold text-secondary dark:text-dark-text mb-4">
                    Page Not Found
                </h2>
                <p className="text-lg md:text-xl text-secondary-300 dark:text-dark-text-secondary mb-8 max-w-lg mx-auto">
                    Oops! The page you're looking for seems to have wandered off. Let's get you back on track.
                </p>

                {/* Action Buttons */}
                <div className="flex flex-row gap-4 justify-center items-center">
                    <Link
                        to="/"
                        className="group flex items-center justify-center gap-3 px-8 py-4 bg-primary text-white font-semibold rounded-xl hover:bg-primary/90 transition-all duration-300 shadow-lg hover:shadow-xl hover:scale-105 w-full sm:w-auto"
                    >
                        <FaHome className="text-xl group-hover:rotate-12 transition-transform duration-300" />
                        <span>Go Home</span>
                    </Link>
                    <Link
                        to="/c/new"
                        className="group flex items-center justify-center gap-3 px-8 py-4 bg-secondary dark:bg-dark-bg-tertiary text-white font-semibold rounded-xl hover:bg-secondary-400 dark:hover:bg-dark-bg-hover transition-all duration-300 shadow-lg hover:shadow-xl hover:scale-105 w-full sm:w-auto"
                    >
                        <FaComments className="text-xl group-hover:scale-110 transition-transform duration-300" />
                        <span>Contact Us</span>
                    </Link>
                </div>

                {/* Decorative Elements */}
                <div className="mt-16 flex justify-center gap-3">
                    <div className="w-3 h-3 rounded-full bg-primary animate-pulse"></div>
                    <div className="w-3 h-3 rounded-full bg-primary animate-pulse delay-75"></div>
                    <div className="w-3 h-3 rounded-full bg-primary animate-pulse delay-150"></div>
                </div>

                {/* Additional Help Text */}
                <p className="mt-8 text-sm text-secondary-200 dark:text-dark-text-secondary">
                    Need help?{' '}
                    <Link to="/" className="text-primary hover:underline font-medium">
                        Contact support
                    </Link>
                </p>
            </div>
        </div>
    );
}
